import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Col, UncontrolledTooltip } from 'reactstrap';
import { dateToString } from '../../common/utils/date/Date.utils';
import { preparePriceFormat } from '../../helpers/preparePriceFormat';
import { formatOrganizationLocation } from '../../helpers/formatOrganizationLocation';
import refundIcon from '../../assets/img/icons/refund.svg';
import downloadIcon from '../../assets/img/icons/download.svg';

function TransactionsTable({
  item,
  setShowAlert,
  setSelectedTransactionId,
  refundedTransactions,
  handleInvoiceDownload,
  handleCreditNoteDownload,
}) {
  const {
    id,
    serial,
    amountInPence,
    title,
    createdOn,
    organizationLocation,
    paymentStatus,
    organization,
    hasCreatedInvoice,
    hasCreatedCreditNote,
  } = item;
  const isRefunded = refundedTransactions.includes(id) || paymentStatus === 'REFUNDED';

  return (
    <>
      <td className="fw-semibold">{serial ?? '-'}</td>
      <td>{preparePriceFormat(amountInPence, true) ?? '-'}</td>
      <td>{title ?? '-'}</td>
      <td>{createdOn ? dateToString(createdOn) : '-'}</td>
      <td>{organization.tradeName ?? '-'}</td>
      <td>{formatOrganizationLocation(organizationLocation) || '-'}</td>
      <td>{paymentStatus ? paymentStatus.replaceAll('_', ' ') : '-'}</td>
      <td className="transactions-table__action-cell">
        <Button
          className="btn-icon rounded-circle btn-ghost-light"
          id={`tooltip_refund${id}`}
          size="sm"
          type="button"
          disabled={isRefunded || paymentStatus !== 'SUCCESS'}
          onClick={() => {
            setSelectedTransactionId(id);
            setShowAlert(true);
          }}
        >
          <img src={refundIcon} alt="Refund icon" />
        </Button>
        <UncontrolledTooltip
          delay={0}
          className="uncontrolled-tooltip-refund"
          target={`tooltip_refund${id}`}
        >
          Refund
        </UncontrolledTooltip>
        <div id={`tooltip_download${id}`} style={{ margin: '4px' }}>
          <Button
            className="btn-icon rounded-circle btn-ghost-light"
            size="sm"
            type="button"
            disabled={!hasCreatedInvoice}
            onClick={() => {
              if (isRefunded && hasCreatedCreditNote) return;
              handleInvoiceDownload(id);
            }}
          >
            <img src={downloadIcon} alt="Download icon" />
          </Button>
        </div>
        {isRefunded && hasCreatedCreditNote && (
          <UncontrolledTooltip
            delay={{ show: 100, hide: 100 }}
            autohide={false}
            innerClassName="m-0 p-0"
            className="transactions-table__invoice-tooltip"
            target={`tooltip_download${id}`}
          >
            <Col className="transactions-table__invoice-tooltip">
              <Col
                className="transactions-table__invoice-tooltip-btn cursor-pointer card-title btn-primary"
                onClick={() => {
                  handleInvoiceDownload(id);
                }}
              >
                Download invoice
              </Col>
              <Col
                className="transactions-table__invoice-tooltip-btn cursor-pointer card-title btn-primary"
                onClick={() => {
                  handleCreditNoteDownload(id);
                }}
              >
                Download credit note
              </Col>
            </Col>
          </UncontrolledTooltip>
        )}
      </td>
    </>
  );
}

TransactionsTable.propTypes = {
  item: PropTypes.object.isRequired,
};

export default TransactionsTable;
